import { accountAPI } from "services";
import SubMenu from "./SubMenu";
import { formatMoney } from "utils";

const Account = ({ account, isSelected, onSelect, accountRef }) => {

  const reminderData = account.get("reminder");
  const nowTime = new Date().getTime();
  const remindBool = reminderData && nowTime > (new Date(reminderData?.date).getTime() || 0);
  const isSharedAccount = accountAPI.checkIsSharedAccount(account);
  const isSharedByMe = accountAPI.checkIsSharedByMe(account);

  const balance = isSharedAccount ? (account.get("balance") * -1) : account.get("balance");
  const accountName = isSharedAccount ? account.get("sharedAcc")?.sharedBy : account.get("name");
  const accountClass = isSelected ? "bg-app-light bg-opacity-25" : (isSharedAccount || isSharedByMe) ? "bg-app-accent bg-opacity-25" : "bg-transparent border-none";

  return (
    <li role="button" className={`list-group-item ${accountClass}`} ref={accountRef}>
      <div className="row fs-5">
        <div className="col-11 py-2 row" onClick={onSelect}>
          <div className={`col-8 col-8 ${account.get("cancelled")
            ? " text-muted text-decoration-line-through"
            : "fw-bold"}`}>
            {remindBool && <i className="bi bi-patch-exclamation-fill text-danger me-2" title="Payment Due!"></i>}
            {isSharedByMe && (
              <i className="bi bi-arrow-up-square-fill text-app me-2" title="Shared By You"></i>
            )}
            {isSharedAccount && (
              <i className="bi bi-arrow-down-square-fill text-app me-2" title="Shared With You"></i>
            )}
            <span className="fs-6">{accountName?.length > 50
              ? accountName.substring(0, 50) + " ..."
              : accountName}</span>
            <span className="ms-2 badge border-app text-app">
              {account.get("tag")}
            </span>
          </div>
          <div className="col-4 text-end">
            <span className={`fs-6 fw-bold text-nowrap ${balance < 0 ? "text-danger" : "text-success"}
              ${account.get("cancelled") ? "text-muted text-decoration-line-through" : ""}`}>
              {formatMoney(Math.abs(balance))}
            </span>
          </div>
        </div>
        <div className="col-1">
          <SubMenu account={account} onSelect={onSelect} isSharedAccount={isSharedAccount} />
        </div>
      </div>
    </li>
  );
};

export default Account;